export const validateDates = ({
  start,
  end,
  due_date,
}: {
  start: string;
  end?: string;
  due_date: string;
}) => {
  const startUTC = new Date(start?.toLocaleString());

  const endUTC = end && new Date(end.toLocaleString());

  const dueDateUTC = new Date(due_date?.toLocaleString());

  if (endUTC && startUTC > endUTC) {
    return {
      type: "end",
      message: "Error: The start date is after the end date.",
    };
  }

  if (startUTC > dueDateUTC) {
    return {
      type: "due_date",
      message: "Error: The start date is after the due date.",
    };
  }

  return null;
};
